import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from '@fortem-monorepo/js-utilities';
import { Sidebar, SidebarProvider } from '@fortem-monorepo/react-ui';
export const PageSidebar = ({ style, className, sticky = false, children, ...props }) => {
    return (_jsx(SidebarProvider, { open: true, className: 'w-auto h-full min-h-full', children: _jsx(Sidebar, { collapsible: 'none', className: cn(['border-r'], {
                ['sticky top-0 h-screen!']: sticky,
            }, className), style: {
                minHeight: 'auto',
                height: `100%`,
                ...style,
            }, ...props, children: children }) }));
};
